module.exports = __webpack_public_path__ + "img/scott-akins.d1c4ce35.jpeg";